import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import Slider from "react-slick";
import { packageAction, testAction } from "../../redux/action";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import ImgPlaceHolder from "../../constant/imgPlaceholder";
import SeoAdd from "../Seo/SeoAdd";
import { FDiscount, getSelectedCityData } from "../../constant/utils";
import Pagination from "rc-pagination";
// import "rc-pagination/assets/index.css";

import BookButton from "./BookButton";
import { useTranslation } from "react-i18next";
import SectionLoader from "../LodingScreen/SectionLoader";
import SendQueryModal from "../packageDetail/SendQueryModal";
import RequestWelcomePopup from "../../layout/header/RequestPopUpForm";
import { ShareTestModal } from "../ShareTestModal/indes";
import { resetFilters, setFilters } from "../../redux/test/reducer";

const BookATest = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { subCategorySlug } = useParams<any>();
  const location = useLocation<any>();
  const history = useHistory<any>();
  const [isFetching, setIsFetching] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(false);
  const [tests, setTests] = useState<any[]>([]);
  const [packages, setPackages] = useState<any[]>([]);
  const [selectedTest, setSelectedTest] = useState<any>(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [limit, setLimit] = useState(10);
  const [shareModal, setShareModal] = useState(false);

  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [code, setCode] = useState<any>("");
  const [subCategoryCount, setsubCategoryCount] = useState<Number>(2);
  const [error, setError] = useState<boolean>(false);

  const [DepName, setDepName] = useState("");
  const [category, setCategory] = useState("");
  const [pricePSort, setPricePSort] = useState("price_low_to_high");
  const [priceTSort, setPriceTSort] = useState("price_low_to_high");
  const [offsetT, setOffsetT] = useState(0);
  const [offsetP, setOffsetP] = useState(0);
  const [page, setPage] = useState(1);
  const [searchTermShow, setSearchTermShow] = useState("");
  // const [searchTerm, setSearchTerm] = useState("");
  const [selectedSubCategoryName, setSelectedSubCategoryName] = useState("");
  const observerRef = useRef<any>(null);

  const testData = useSelector((state: any) =>
    state.test.list ? state.test.list : {},
  );
  const { searchTerm, tab, subCategory, department } = useSelector(
    (state: any) => state.test.filters,
  );

  const getSelectTest = `https://oncquestlabs.com${ROUTE.TESTDETAILS}/${selectedTest?.Slug}`;

  const getSubCategory = location.state?.categoryData;
  useEffect(() => {}, [getSubCategory]);

  const packageData = useSelector((state: any) =>
    state.package.list ? state.package.list : {},
  );
  const subCategoryLoader = useSelector(
    (state: any) => state.package.subCategory,
  );
  const subCategoryData = useSelector(
    (state: any) => state.package.subCategory?.Categories,
  );

  const commonLoading: any = useSelector((state: any) =>
    state.common.loader ? state.common.loader : false,
  );
  const CityId: any = localStorage.getItem("oq:city");
  const handleModalOpen = (code: any) => {
    setCode(code);
    setModalIsOpen(true);
  };
  const isHcAvailable = getSelectedCityData()?.IsHcAvailable == 1;

  useEffect(() => {
    if (subCategoryData?.length === 7) {
      setsubCategoryCount(0);
    } else if (subCategoryData?.length === 9) {
      setsubCategoryCount(1);
    } else {
      setsubCategoryCount(2);
    }
  }, [subCategoryData]);

  useEffect(() => {
    console.log(
      "SubCategorySlug:",
      subCategorySlug,
      "SubCategoryData:",
      subCategoryData,
    );
    if (!subCategorySlug) return;
    if (subCategorySlug && subCategoryData?.length > 0) {
      const selectedSubCat = subCategoryData.find(
        (item: any) => item.CategorySlug === subCategorySlug,
      );
      if (selectedSubCat) {
        dispatch(setFilters({ subCategory: subCategorySlug }));
        setSelectedSubCategoryName(selectedSubCat.CategoryName);
      }
    }
  }, [subCategorySlug, subCategoryData]);

  const isFirstLoad = useRef(true);

  // search url
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const search = params.get("search");

    if (search) {
      dispatch(setFilters({ searchTerm: search }));
      setSearchTermShow(search);
    } else {
      dispatch(resetFilters());
      setSearchTermShow("");
      setSelectedSubCategoryName("");
    }
  }, []);

  useEffect(() => {
    if (!location?.state || !isFirstLoad.current) return;

    const state: any = location.state;
    let updatedFilters: any = {};

    if (state?.categoryId === 85) {
      updatedFilters.tab = "organs";
    } else if (state?.categoryId === 84) {
      updatedFilters.tab = "lifestyle";
    } else if (state?.tabs) {
      updatedFilters.tab = state?.tabs;
    }

    if (state?.categoryId) {
      setCategory(state.categoryId);
    }

    if (state?.depId) {
      updatedFilters.department = state.depId;
    }

    if (state?.depName) {
      setDepName(state.depName);
    }
    if (Object.keys(updatedFilters).length > 0) {
      dispatch(setFilters(updatedFilters));
    }

    isFirstLoad.current = false;
  }, [location?.state, dispatch]);

  const getTestShareURL = (Id: number) => {
    const test = tests.find((item) => item.Id === Id);
    if (test) {
      setSelectedTest(test);
      setShareModal(true);
    }
  };

  useEffect(() => {
    setTests([]);
    setPage(1);
    setOffsetT(0);
    setIsInitialLoading(true);
    setIsFetching(false);
  }, [tab, subCategory, searchTerm, priceTSort, department, CityId]);

  useEffect(() => {
    if (Array.isArray(testData?.Tests)) {
      const newData = testData.Tests || [];

      setTests((prev) => {
        if (offsetT === 0) {
          return newData;
        }

        const merged = [...prev, ...newData].filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.Id === item.Id),
        );

        return merged;
      });
      setIsFetching(false);
      setIsInitialLoading(false);
    }
  }, [offsetT, testData]);

  useEffect(() => {
    if (!CityId || isFetching) return;
  
    if (
      offsetT !== 0 &&
      testData?.TotalTests !== undefined &&
      offsetT >= testData.TotalTests
    )
      return;
    setIsFetching(true);


    setError(false);

    const categoryMap: any = {
      tests: "",
      organs: "organs",
      lifestyle: "lifestyles",
      packages: "",
    };



    let categorySlug = "";

    if (subCategory) {
      categorySlug = subCategory; 
    } else {
      categorySlug = categoryMap[tab] || "";
    }

    console.log("Test Fetch Payload:", {
      SearchTerm: searchTerm,
      Offset: offsetT,
      Limit: limit,
      DepartmentId: department,
      CityId: CityId,
      sort_by: priceTSort,
      CategorySlug: categorySlug,
    });

    dispatch(
      testAction.listTestAction({
        SearchTerm: searchTerm,
        Offset: offsetT,
        Limit: limit,
        DepartmentId: department,
        CityId: CityId,
        sort_by: priceTSort,
        CategorySlug: categorySlug,
        ...(tab === "packages" && {IsOpdPackage : 1}),
        ...(tab === "tests" && {IsOpdPackage : 0})
       
      }),
    );

    const subCategoryIdMap: any = {
      lifestyle: 84,
      organs: 85,
      tests: "",
      packages: "",
    };

    const subCategoryId = subCategoryIdMap[tab];
    if (subCategoryId !== null) {
      dispatch(packageAction.getSubCategoryByIdAction(subCategoryId));
    }

    return () => {
      let state: any = { ...history.location.state };
      if (history.location.state && history.location.state.depId) {
        delete state.depId;
      }
      if (history.location.state && history.location.state.depName) {
        delete state.depName;
      }
      history.replace({ ...history.location, state });
    };
    // }, [offsetT, searchTerm, tab, subCategory, CityId, priceTSort]);
  }, [
    CityId,
    department,
    dispatch,
    history,
    limit,
    offsetT,
    priceTSort,
    searchTerm,
    subCategory,
    tab,
    refreshKey
  ]);

  useEffect(() => {
    if (!observerRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          if (tests.length < testData?.TotalTests && !isFetching) {
            setOffsetT((prev) => prev + limit);
          }
        }
      },
      {
        rootMargin: "200px",
        threshold: 0,
      },
    );

    observer.observe(observerRef.current);

    return () => observer.disconnect();
  }, [isFetching, limit, testData?.TotalTests, tests.length]);

  useEffect(() => {
    if (category !== "") {
      dispatch(packageAction.getSubCategoryByIdAction(category));
    }
  }, [category]);

  useEffect(() => {
    setSearchTermShow(searchTerm || "");
  }, [searchTerm]);

  const handlePricePackageSort = (e: any) => {
    setPage(1);
    setOffsetT(0);
    setOffsetP(0);
    setPricePSort(e.target.value);
  };
  const handlePriceTestSort = (e: any) => {
    setPage(1);
    setOffsetT(0);
    setOffsetP(0);
    setPriceTSort(e.target.value);
  };

  const handlePaginationP = (page: number) => {
    setOffsetP((page - 1) * limit);
    setPage(page);
  };
  const handlePaginationT = (page: number) => {
    setOffsetT((page - 1) * limit);
    setPage(page);
  };

  const [settings, setSettings] = useState<any>(null);

  useEffect(() => {
    setSettings({
      infinite: true,
      speed: 1000,
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: true,
      rows:
        (subCategory && (category === "85" || category === "84")) ||
        subCategoryCount === 0 ||
        subCategoryCount === 1
          ? 1
          : 2,
      slidesPerRow: 1,
      autoplay: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            rows:
              (getSubCategory && (category === "85" || category === "84")) ||
              subCategoryCount === 0 ||
              subCategoryCount === 1
                ? 1
                : 2,
            slidesPerRow: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            rows:
              (getSubCategory && (category === "85" || category === "84")) ||
              subCategoryCount === 0 ||
              subCategoryCount === 1
                ? 1
                : 2,
            slidesPerRow: 1,
            dots: false,
            arrows: true,
          },
        },
        {
          breakpoint: 577,
          settings: {
            slidesToShow: 2,
            rows:
              (getSubCategory && (category === "85" || category === "84")) ||
              subCategoryCount === 0 ||
              subCategoryCount === 1
                ? 1
                : 2,
            slidesPerRow: 1,
            slidesToScroll: 2,
            infinite: true,
            dots: false,
            arrows: true,
          },
        },
      ],
    });
  }, [getSubCategory, subCategoryCount]);

  function GetPKGColorTitle1(title: any = "") {
    let _title: any[] = title?.split(" ");
    let len: number = _title?.length;
    let title1 = _title?.slice(Math.ceil(2))?.join(" ");
    let title2 = title.replace(title1, "");
    return (
      <>
        <span style={{ color: "#FFFFFF" }}>{title2}</span>
      </>
    );
  }

  const handleSubCatChange = (e: any, subCategorySlug: any) => {
    console.log("SubCategorySlug Clicked:", subCategorySlug);
    e.preventDefault();
    setPage(1);
    setOffsetT(0);
    setOffsetP(0);
    dispatch(setFilters({ subCategory: subCategorySlug }));
    const selectedSubCategory = subCategoryData?.find(
      (item: any) => item.CategorySlug === subCategorySlug,
    );
    setSelectedSubCategoryName(selectedSubCategory?.CategoryName || "");

    history.replace(`${ROUTE.BOOKATEST}/${subCategorySlug}`);
  };

  const handleSearch = (e: any) => {
    let val = e.target.value;
    setSearchTermShow(val);

    if ((val && val.trim().length >= 3) || val.length === 0) {
      dispatch(setFilters({ searchTerm: val }));

    
      history.replace({
        pathname: ROUTE.BOOKATEST,
        search: val ? `?search=${val}` : "",
      });
    }

    setTests([]);
    setOffsetT(0);
  };

  const handleTab = (e: any, value: string) => {
    e.preventDefault();
    const isSameTab = tab === value;
     setIsInitialLoading(true);
    dispatch(
      setFilters({
        tab: value,
        subCategory: "",
        department: "",
        searchTerm: "",
      }),
    );

    setSelectedSubCategoryName("");
    setSearchTermShow("");
    setTests([]);
    setOffsetT(0);
    if(isSameTab){
      setRefreshKey((prev) => prev + 1)
    }

    history.replace(ROUTE.BOOKATEST);
  };

  const clearFilter = () => {
    dispatch(resetFilters());

    setSelectedSubCategoryName("");
    setSearchTermShow("");
    setTests([]);
    setOffsetT(0);
    setCategory("");

   
    history.replace(ROUTE.BOOKATEST);
  };

  const renderPagination = (type: "tests" | "packages") => {
    const total =
      type === "tests" ? testData?.TotalTests : packageData?.TotalPackages;
    const offset = type === "tests" ? offsetT : offsetP;
    const items = type === "tests" ? tests : packages;
    const handlePagination =
      type === "tests" ? handlePaginationT : handlePaginationP;
    const pageSize = 500;
    return (
      total > 0 &&
      items?.length > 0 && (
        <div className="row justify-content-between my-3">
          <div className="col-md-3"></div>
          <div className="col-md-9 d-flex justify-content-end align-items-center">
            {/* <div className="mr-3 f-14">
              {`${t("Showing")} 
              ${offset + 1} - ${offset + items?.length} ${t("of")} ${total} ${t("result")}`}
            </div> */}

            {/* <div className="ml-3 f-14">
              {`${t("Showing")} ${offsetT + 1} - ${Math.min(
                offsetT + limit,
                testData?.TotalTests,
              )} ${t("of")} ${testData?.TotalTests} ${t("result")}`}
            </div> */}

            {/* <div className="ml-3 f-14">
              {`${t("Showing")} 1 - ${Math.min(
                offsetT + limit,
                testData?.TotalTests,
              )} ${t("of")} ${testData?.TotalTests} ${t("result")}`}
            </div>

            <div className="ml-3">
              <Pagination
                locale={{ prev_page: "Prev", next_page: "Next" }}
                onChange={handlePagination}
                current={page}
                total={total}
                pageSize={pageSize}
              />
            </div> */}
          </div>
        </div>
      )
    );
  };

  return (
    <div>
      {showPopup && (
        <RequestWelcomePopup
          showPopup={showPopup}
          setShowPopup={setShowPopup}
        />
      )}
      <SeoAdd slug={ROUTE.BOOKATEST} />
      <div>
        <section className="bg-white">
          <div className="container">
            <div className="row justify-content-between align-items-center parent-sticky-mobile-only">
              <div className="sticky-mobile-only book-sec">
                <div className="no-breadcrumb-margin">
                  <BreadCrumb
                    page={t("bread_tests_and_packages")}
                    data={{ slug: DepName, path: "#" }}
                  />
                </div>

                <div className="search-filter-div">
                  <div className="col-md-5">
                    <div
                      className="input-group"
                      style={{ padding: "10px 0px" }}
                    >
                      <input
                        className="form-control rounded-pill py-2 pr-5 mr-1 bg-transparent"
                        type="search"
                        value={searchTermShow}
                        placeholder={t("search_teast_packages")}
                        id="example-search-input"
                        onChange={handleSearch}
                      />
                      <span className="input-group-append">
                        <div className="input-group-text border-0 bg-transparent ml-n5">
                          <i
                            className="fa fa-search"
                            style={{ color: "#114A82" }}
                          ></i>
                        </div>
                      </span>
                    </div>
                  </div>
                  <div>
                    {(searchTerm ||
                      subCategory ||
                      subCategorySlug ||
                      department) && (
                      <div className="mt-4 mt-md-0">
                        <button
                          className="book--hexagon active m-0"
                          onClick={() => clearFilter()}
                        >
                          <span className="text-capitalize">
                            Clear Filter
                            <i
                              className="fa fa-times ml-20"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </button>
                      </div>
                    )}
                  </div>
                  <div
                    className="col-md-5 packages tbs d-flex justify-content-end  mt-lg-0 mr-0 category-tabs-mobile"
                    style={{ maxWidth: "380px" }}
                  >
                    <ul
                      className="nav nav-tabs m-0 p-0 book-tabs"
                      style={{ display: "flex", flexWrap: "nowrap", }}
                    >
                      <li onClick={(e) => handleTab(e, "lifestyle")}>
                        <a className={tab === "lifestyle" ? "active" : ""}>
                          {t("lifestyle")}
                        </a>
                      </li>

                      <li onClick={(e) => handleTab(e, "organs")}>
                        <a className={tab === "organs" ? "active" : ""}>
                          {t("organs")}
                        </a>
                      </li>
                     
                      <li
                        onClick={(e) => handleTab(e, "tests")}
                        className="cust-test-btn"
                      >
                        <a className={tab === "tests" ? "active" : ""}>
                          {t("test")}
                        </a>
                      </li>
                       <li onClick={(e) => handleTab(e, "packages")}>
                        <a className={tab === "packages" ? "active" : ""}>
                          {t("packages")}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* <div
                className="col-md-5 packages tbs d-flex justify-content-end mt-4 mt-lg-0 mr-0 category-tabs-desktop"
                style={{ maxWidth: "380px" }}
              >
                <ul
                  className="nav nav-tabs m-0 p-0"
                  style={{ display: "flex", flexWrap: "nowrap" }}
                >
                  <li onClick={(e) => handleTab(e, "lifestyle")}>
                    <a className={tab === "lifestyle" ? "active" : ""}>
                      {t("lifestyle")}
                    </a>
                  </li>

                  <li onClick={(e) => handleTab(e, "organs")}>
                    <a className={tab === "organs" ? "active" : ""}>
                      {t("organs")}
                    </a>
                  </li>
                  <li onClick={(e) => handleTab(e, "organs")}>
                    <a className={tab === "packages" ? "active" : ""}>
                      {t("packages")}
                    </a>
                  </li>
                  <li
                    onClick={(e) => handleTab(e, "tests")}
                    className="cust-test-btn"
                  >
                    <a className={tab === "tests" ? "active" : ""}>
                      {t("test")}
                    </a>
                  </li>
                </ul>
              </div> */}
            </div>
            {Object.keys(subCategoryLoader)?.length > 0 ? (
              <>
                {settings && subCategoryData && subCategoryData?.length > 0 && (
                  <div className="container">
                    <div className="row justify-content-center align-items-center book-slider">
                      <div className="col pkj_slider packages" id="pkj-sli">
                        <Slider {...settings}>
                          {subCategoryData &&
                            subCategoryData?.length > 0 &&
                            subCategoryData?.map((item: any, i: any) => (
                              <ul className="nav nav-tabs" key={item?.Id}>
                                <li
                                  onClick={(e: any) =>
                                    handleSubCatChange(e, item?.CategorySlug)
                                  }
                                  className={
                                    subCategorySlug === item?.CategorySlug
                                      ? "subCat active"
                                      : "subCat"
                                  }
                                >
                                  <a
                                    href="#"
                                    onClick={(e: any) => e.preventDefault()}
                                  >
                                    <div className="d-flex flex-row justify-content-start align-items-center">
                                      <div>
                                        <img
                                          src={
                                            item?.CategoryIcon &&
                                            item?.CategoryIcon
                                          }
                                          onError={(e: any) =>
                                            ImgPlaceHolder(
                                              e,
                                              "/assets/img/s1.png",
                                            )
                                          }
                                          className="scale_subIcon"
                                          alt=""
                                          style={{ borderRadius: "50%" }}
                                        />
                                      </div>
                                      <div className="ml-0 ml-lg-2 text-capitalize">
                                        {t(item?.CategoryName)}
                                      </div>
                                    </div>
                                  </a>
                                </li>
                              </ul>
                            ))}
                        </Slider>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              CityId && <SectionLoader />
            )}
          </div>
        </section>
      </div>

      <section className="sub-section bg-white packageService">
        <div className="tab-content">
          {/* <div
            id="packages"
            className={
              tab == "lifestyle" || tab === "organs"
                ? "tab-pane fade in active show"
                : "tab-pane fade in"
            }
          >
            <div className="container">
              <div className="d-flex flex-row flex-wrap justify-content-between">
                <div className="d-flex flex-row justify-content-start align-items-baseline">
                  <div className="headingmains text-left mr-3 mb-3">
                    <h1 className="right aos-init pb-2 text-capitalize test-pkg-head">
                      {t("packages")}
                    </h1>
                  </div>
                  {packages?.length > 0 && (
                    <div className="ml-3 f-14">{`Showing  ${
                      packages?.length === 0 ? 0 : offsetP + 1
                    } - ${offsetP + packages?.length} of ${
                      packageData?.TotalPackages
                    } Result`}</div>
                  )}
                </div>
                {packages?.length > 0 && (
                  <div className="form-group d-flex flex-row justify-content-between align-items-center">
                    <div className="text-center f-14 mr-3">{t("sort_by")}</div>
                    <select
                      id="inputState"
                      className="form-control rounded-pill sort_select"
                      value={pricePSort}
                      onChange={handlePricePackageSort}
                    >
                      <option value="a_to_z">{t("atz")}</option>
                    </select>
                  </div>
                )}
              </div>
              {tab === "packages" &&
              !commonLoading &&
              Object.keys(packageData)?.length > 0 ? (
                <>
                  <div className="equal_clm h-services">
                    {packages && packages?.length > 0 ? (
                      packages?.map((item: any, i: any) => (
                        <div className="infobox_wrapper pkj_wrap_box" key={i}>
                          <div>
                            <div>
                              {FDiscount(item?.MRP, item?.SellingPrice) ? (
                                <div className="dis_icon text-center">
                                  <img
                                    src="/assets/img/discount.jpeg"
                                    className="scale"
                                  />
                                  <span className="img_text_center">
                                    {FDiscount(item?.MRP, item?.SellingPrice)}{" "}
                                    <br />
                                    {t("off")}
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                              <div className="infobox_icon_container ">
                                <img
                                  src="/assets/img/test_blood.png"
                                  className="scale circle_img"
                                />
                              </div>

                              <h3 className="infobox_title text-uppercase">
                                {item?.PackageName}
                              </h3>
                              <div className="infobox_lines">
                                {" "}
                                <img
                                  src="/assets/img/info.png"
                                  className="scale_booknow"
                                />
                                {item?.Recommendation}
                              </div>
                              {item?.PackageCode ? (
                                <div className="infobox_lines">
                                  {" "}
                                  <img
                                    src="/assets/img/parameter.png"
                                    className="scale_booknow"
                                  />
                                  {item?.PackageCode}
                                  {item?.ComponentCount
                                    ? item?.ComponentCount
                                    : 0}
                                  {" Parameter(s) covered"}
                                </div>
                              ) : (
                                ""
                              )}

                              <div className="infobox_lines">
                                {" "}
                                <img
                                  src="/assets/img/daily.png"
                                  className="scale_booknow"
                                />
                                {item?.ReportTAT}
                              </div>

                              {item?.SampleReportFile && (
                                <a
                                  href={item?.SampleReportFile}
                                  target="_blank"
                                  className="infobox_lines"
                                >
                                  {" "}
                                  <img
                                    src="/assets/img/report.png"
                                    className="scale_booknow"
                                  />
                                  {t("sample_report")}
                                </a>
                              )}
                              <Link
                                to={`${ROUTE.PACKAGEDETAILS}/${item?.Slug}`}
                                className="moreButton"
                              >
                                {t("more_btn")}
                              </Link>
                              <div className="d-flex justify-content-between align-items-baseline">
                                <div>
                                  {item?.MRP !== item?.SellingPrice && (
                                    <span className="price-redtext">
                                      ₹{`${item?.MRP}`}
                                    </span>
                                  )}{" "}
                                  <span className="price-bluetext">
                                    ₹{`${item?.SellingPrice}`}
                                  </span>
                                </div>
                                {item?.MRP - item?.SellingPrice > 0 ? (
                                  <div>
                                    <span className="price-greentext">
                                      {t("save")} ₹
                                      {item?.MRP - item?.SellingPrice}
                                    </span>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                              <BookButton type={"package"} data={item} />
                              <a
                                href={"#"}
                                className="button--hexagon booknow mt-0"
                                onClick={() =>
                                  handleModalOpen(item?.PackageName)
                                }
                              >
                                <span>
                                  GET A CALL BACK
                                  <i
                                    className="fa fa-long-arrow-right ml-20"
                                    aria-hidden="true"
                                  ></i>
                                </span>
                              </a>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="singl_clm text-center text-dark fs-18 mt-0">
                        {error
                          ? "Currently online booking facility is not available in the selected city. You can fill the form and submit, our team will contact you back."
                          : packageData && Array.isArray(packageData?.Packages)
                            ? "No Package Data Available"
                            : null}
                        {error && (
                          <div>
                            <a
                              href=""
                              className="button--hexagon mt-2"
                              style={{ width: "230px" }}
                              onClick={(e: any) => {
                                e.preventDefault();
                                setShowPopup(true);
                              }}
                            >
                              <span>
                                Request a call
                                <i
                                  className="fa fa-long-arrow-right ml-20"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </a>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {renderPagination("packages")}
                </>
              ) : (
                CityId && <SectionLoader />
              )}
            </div>
          </div> */}
          <div id="tests">
            <div className="container">
              <div className="d-flex flex-row flex-wrap justify-content-between">
                <div className="d-flex flex-row justify-content-start align-items-baseline">
                  <div className="headingmains text-left mr-3 mb-3">
                    <h1 className="right aos-init pb-2 text-capitalize test-pkg-head">
                      {selectedSubCategoryName || t(tab)}
                    </h1>
                  </div>
                  {/* {tests?.length > 0 && (
                    <div className="ml-3 f-14">{`${t("Showing")}  ${
                      tests?.length === 0 ? 0 : offsetT + 1
                    } - ${offsetT + tests?.length} ${t("of")} ${
                      testData?.TotalTests
                    } ${t("result")}`}</div>
                  )} */}
                  {tests?.length > 0 && (
                    <div className="ml-3 f-14">{`${t("Showing")}  ${
                      tests?.length === 0 ? 0 : 1
                    } - ${tests?.length} ${t("of")} ${
                      testData?.TotalTests
                    } ${t("result")}`}</div>
                  )}
                </div>
              </div>

              {/* {commonLoading || isFetching ? (
                CityId && <SectionLoader />
              ) :  */}
              {isInitialLoading ? (
                <div className="text-center py-5">
                  <SectionLoader />
                </div>
              ) : tests?.length > 0 ? (
                <>
                  <div className="equal_clm h-services organslider">
                    {tests && tests.length > 0 ? (
                      tests?.map((item: any, i: any) => (
                        <div className="infobox_wrapper pkj_wrap_box" key={i}>
                          <div>
                            <div>
                              {FDiscount(item?.MRP, item?.SellingPrice) ? (
                                <div className="dis_icon text-center">
                                  <img
                                    src="/assets/img/discount.jpeg"
                                    className="scale"
                                  />
                                  <span className="img_text_center">
                                    {FDiscount(item?.MRP, item?.SellingPrice)}{" "}
                                    <br />
                                    {t("off")}
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                              <div
                                style={{
                                  height: "100%",
                                  marginBottom: "3rem",
                                }}
                              >
                                <div
                                  className="infobox_icon_container test-deta-info"
                                  id=""
                                ></div>
                                <div className="d-flex justify-content-between">
                                  <h3
                                    className="infobox_title text-uppercase"
                                    style={{ width: "85%" }}
                                  >
                                    {item?.TestName}
                                  </h3>

                                  <p
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      getTestShareURL(item.Id);
                                    }}
                                  >
                                    <img
                                      src="/assets/img/share-icons-tests.png"
                                      alt="Share Icon"
                                      className="share-icons-test"
                                    />
                                  </p>
                                </div>

                                {item?.TestCode ? (
                                  <div className="infobox_lines">
                                    {" "}
                                    <img
                                      src="/assets/img/parameter.png"
                                      className="scale_booknow"
                                    />
                                    {item?.TestCode}
                                  </div>
                                ) : (
                                  ""
                                )}

                                <div className="infobox_lines">
                                  {" "}
                                  <img
                                    src="/assets/img/daily.png"
                                    className="scale_booknow"
                                  />
                                  {item?.Days} {" "}
                               
                                  {/* {item?.Days === 0
                                    ? "Same Day"
                                    : item?.Days !== null &&
                                        item?.Days !== undefined
                                      ? `${item.Days} Days`
                                      : ""} */}
                                </div>

                                {/* {item?.SampleReportFile && (
                                  <a
                                    href={item?.SampleReportFile}
                                    target="_blank"
                                    className="infobox_lines"
                                  >
                                    {" "}
                                    <img
                                      src="/assets/img/report.png"
                                      className="scale_booknow"
                                    />
                                    {t("sample_report")}
                                  </a>
                                )} */}

                                <Link
                                  to={`${ROUTE.TESTDETAILS}/${item?.Slug}`}
                                  className="moreButton"
                                >
                                  {t("plus_more")}
                                </Link>

                                <div className="d-flex justify-content-between align-items-baseline">
                                  <div>
                                    {item?.MRP !== item?.SellingPrice && (
                                      <span className="price-redtext">
                                        ₹{`${item?.MRP}`}
                                      </span>
                                    )}{" "}
                                    <span className="price-bluetext">
                                      ₹{`${item?.SellingPrice}`}
                                    </span>
                                  </div>
                                  {item?.MRP - item?.SellingPrice > 0 ? (
                                    <div>
                                      <span className="price-greentext">
                                        {t("save")} ₹
                                        {item?.MRP - item?.SellingPrice}
                                      </span>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              <div className="book-test-button">
                                <BookButton type={"test"} data={item} />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : isFetching ? null : (
                      <div className="singl_clm text-center text-dark fs-18 mt-0">
                        {error
                          ? "Currently online booking facility is not available in the selected city. You can fill the form and submit, our team will contact you back."
                          : testData && Array.isArray(testData?.Tests)
                            ? "No Test Data Available"
                            : null}
                        {error && (
                          <div>
                            <a
                              href=""
                              className="button--hexagon mt-2"
                              style={{ width: "230px" }}
                              onClick={(e: any) => {
                                e.preventDefault();
                                setShowPopup(true);
                              }}
                            >
                              <span>
                                Request a call
                                <i
                                  className="fa fa-long-arrow-right ml-20"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </a>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div ref={observerRef} style={{ height: "1px" }} />
                  {renderPagination("tests")}

                  {isFetching && (
                    <div className="text-center py-3">
                      <SectionLoader />
                    </div>
                  )}
                </>
              ) : (
                <div className="singl_clm text-center text-dark fs-18 mt-0">
                  {error
                    ? "Currently online booking facility is not available in the selected city. You can fill the form and submit, our team will contact you back."
                    : "No Test Data Available"}
                  {error && (
                    <div>
                      <a
                        href=""
                        className="button--hexagon mt-2"
                        style={{ width: "230px" }}
                        onClick={(e: any) => {
                          e.preventDefault();
                          setShowPopup(true);
                        }}
                      >
                        <span>
                          Request a call
                          <i
                            className="fa fa-long-arrow-right ml-20"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </a>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <SendQueryModal
        modalIsOpen={modalIsOpen}
        setModalIsOpen={setModalIsOpen}
        test={tab == "tests"}
        code={code}
      />
      <ShareTestModal
        shareModal={shareModal}
        setShareModal={setShareModal}
        selectedTest={selectedTest}
        getSelectTest={getSelectTest}
      />
    </div>
  );
};

export default BookATest;
